export default __webpack_public_path__ + "6d9429a4f8381536a6b3e783aab00f93.png";